import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { solutions, site } from "@/content";
import SeoHead from "@/components/feature/SeoHead";

export default function SolutionDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (slug && solutions.find((s) => s.slug === slug)) {
      navigate(`/solutions#${slug}`, { replace: true });
    }
  }, [slug, navigate]);

  return (
    <>
      <SeoHead
        title={site.seo.solutionDetail.title}
        description={site.seo.solutionDetail.description}
        keywords={site.seo.solutionDetail.keywords}
        canonicalPath={`/solution/${slug || ""}`}
      />
    </>
  );
}